(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9227],{

/***/ 43280:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-education",
      function () {
        return __webpack_require__(30329);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ medical_education; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/seo/MetaTitle.tsx
var MetaTitle = __webpack_require__(71508);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./src/components/seo/MetaDescription.tsx
var MetaDescription = __webpack_require__(89080);
// EXTERNAL MODULE: ./src/modules/materials/components/ShowcasePage/index.tsx + 27 modules
var ShowcasePage = __webpack_require__(15030);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./src/hooks/directus/useTranslateItem.ts
var useTranslateItem = __webpack_require__(70057);
// EXTERNAL MODULE: ./src/components/filters/types.ts
var types = __webpack_require__(26026);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/videos/graphql/videos-search-filters.query.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query {\n    subjects {\n      id\n      slug\n      translations {\n        name\n        languages_id {\n          code\n        }\n      }\n    }\n    tags(filter: { videos: { videos_id: { id: { _nnull: true } } } }) {\n      id\n      slug\n      translations {\n        name\n        languages_code {\n          code\n        }\n      }\n    }\n    bodyParts {\n      id\n      slug\n    }\n    durations {\n      id\n      slug\n      translations {\n        name\n        languages_code {\n          code\n        }\n      }\n    }\n    languages {\n      name\n      code\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var videoSearchFiltersGqlQuery = (0,gql_query/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./src/modules/videos/hooks/useVideosShowcaseFiltersQuery.ts








var fetchVideosShowcaseFilters = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis) {
        var translateItem, directus, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    translateItem = (0,useTranslateItem/* translateItemFactory */.l)(apis.language.getCurrentLanguage());
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        4,
                        directus.query(videoSearchFiltersGqlQuery)
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        [
                            {
                                title: "Subject",
                                queryField: "subject",
                                type: types/* FilterType.Multiselect */.v.Multiselect,
                                options: data.subjects.map(translateItem).map(function(s) {
                                    return {
                                        label: s.name,
                                        value: s.slug
                                    };
                                })
                            },
                            {
                                title: "Face Part",
                                queryField: "bodyPart",
                                type: types/* FilterType.Facepart */.v.Facepart,
                                options: data.bodyParts.map(function(s) {
                                    return {
                                        label: s.slug,
                                        value: s.slug
                                    };
                                })
                            },
                            {
                                title: "Tags",
                                queryField: "tag",
                                type: types/* FilterType.Tags */.v.Tags,
                                options: data.tags.map(translateItem).map(function(s) {
                                    return {
                                        label: s.name,
                                        value: s.slug
                                    };
                                })
                            },
                            {
                                title: "Duration",
                                queryField: "duration",
                                type: types/* FilterType.Multiselect */.v.Multiselect,
                                options: data.durations.map(translateItem).map(function(s) {
                                    return {
                                        label: s.name,
                                        value: s.slug
                                    };
                                })
                            },
                            {
                                title: "Audio Language",
                                queryField: "audioLanguage",
                                type: types/* FilterType.Language */.v.Language,
                                options: data.languages.map(function(s) {
                                    return {
                                        label: s.name,
                                        value: s.code
                                    };
                                })
                            },
                            {
                                title: "Subtitle Language",
                                queryField: "subtitleLanguage",
                                type: types/* FilterType.Language */.v.Language,
                                options: data.languages.map(function(s) {
                                    return {
                                        label: s.name,
                                        value: s.code
                                    };
                                })
                            }
                        ]
                    ];
            }
        });
    });
    return function fetchVideosShowcaseFilters(apis) {
        return _ref.apply(this, arguments);
    };
}();
var useVideosShowcaseFiltersQuery = function() {
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)(query/* QueryKey.VideoSearchFilters */.S.VideoSearchFilters, function() {
        return fetchVideosShowcaseFilters(apis);
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/modules/materials/models/showcase.ts
var showcase = __webpack_require__(80614);
;// CONCATENATED MODULE: ./src/modules/videos/hooks/useVideosShowcaseSectionsQuery.ts







var fetchVideosShowcaseSections = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis) {
        var user;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.cachedKratosSession()
                    ];
                case 1:
                    user = _state.sent();
                    return [
                        2,
                        [
                            {
                                name: "Recently added",
                                variables: {
                                    filters: {
                                        status: {
                                            _eq: "published"
                                        },
                                        showcase: {
                                            _eq: true
                                        }
                                    },
                                    sort: [
                                        "-date_created"
                                    ],
                                    limit: 10,
                                    itemsToQuery: [
                                        "videos"
                                    ]
                                },
                                type: showcase/* ShowcaseSection.List */.Y.List,
                                searchQuery: {
                                    recent: "true"
                                }
                            },
                            {
                                name: "Injection techniques",
                                searchQuery: {
                                    subject: "injection-techniques"
                                },
                                taxonomy: {
                                    subject: "injection-techniques"
                                },
                                variables: {
                                    sort: [
                                        "-date_created"
                                    ],
                                    filters: {
                                        showcase: {
                                            _eq: true
                                        },
                                        status: {
                                            _eq: "published"
                                        },
                                        subjects: {
                                            subjects_id: {
                                                slug: {
                                                    _eq: "injection-techniques"
                                                }
                                            }
                                        }
                                    },
                                    limit: 10,
                                    itemsToQuery: [
                                        "videos"
                                    ]
                                },
                                type: showcase/* ShowcaseSection.List */.Y.List
                            },
                            {
                                name: "Trending now",
                                variables: {
                                    sort: [
                                        "-date_created"
                                    ],
                                    filters: {
                                        showcase: {
                                            _eq: true
                                        },
                                        status: {
                                            _eq: "published"
                                        },
                                        trendingNow: {
                                            _eq: true
                                        }
                                    },
                                    limit: 5,
                                    itemsToQuery: [
                                        "videos"
                                    ]
                                },
                                type: showcase/* ShowcaseSection.HeroList */.Y.HeroList
                            }
                        ].concat((0,_to_consumable_array/* default */.Z)(user ? [
                            {
                                name: "My favorites",
                                type: showcase/* ShowcaseSection.Favorites */.Y.Favorites,
                                searchQuery: {
                                    favourites: "true"
                                }
                            }
                        ] : []), [
                            {
                                name: "Protocol treatment",
                                type: showcase/* ShowcaseSection.ProtocolTreatment */.Y.ProtocolTreatment
                            },
                            {
                                name: "Experts talks",
                                type: showcase/* ShowcaseSection.BusinessCases */.Y.BusinessCases
                            },
                            {
                                name: "events",
                                searchQuery: {
                                    subject: "events"
                                },
                                variables: {
                                    sort: [
                                        "-date_created"
                                    ],
                                    filters: {
                                        showcase: {
                                            _eq: true
                                        },
                                        status: {
                                            _eq: "published"
                                        },
                                        subjects: {
                                            subjects_id: {
                                                slug: {
                                                    _eq: "events"
                                                }
                                            }
                                        }
                                    },
                                    limit: 10,
                                    itemsToQuery: [
                                        "videos"
                                    ]
                                },
                                type: showcase/* ShowcaseSection.List */.Y.List
                            }
                        ])
                    ];
            }
        });
    });
    return function fetchVideosShowcaseSections(apis) {
        return _ref.apply(this, arguments);
    };
}();
var useVideosShowcaseSectionsQuery = function() {
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)(query/* QueryKey.VideoFilterSections */.S.VideoFilterSections, function() {
        return fetchVideosShowcaseSections(apis);
    });
};

;// CONCATENATED MODULE: ./src/pages/medical-education/index.tsx







var MedicalEducationPage = function() {
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTitle/* MetaTitle */.p, {
                children: _("Medical Education - Injection Techniques, Expert Talks")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaDescription/* MetaDescription */.l, {
                children: _("	Watch online medical aesthetic videos. Injection techniques, Training, Protocol Treatment and Expert Talks")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowcasePage/* ShowcasePageTemplate */.S, {
                filtersQuery: useVideosShowcaseFiltersQuery,
                sectionsQuery: useVideosShowcaseSectionsQuery,
                itemsToQuery: [
                    "videos"
                ],
                defaultFilters: {
                    showcase: true,
                    status: [
                        "published"
                    ]
                }
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var medical_education = (MedicalEducationPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5689,78,5900,1093,7826,8281,4732,6870,5030,9774,2888,179], function() { return __webpack_exec__(43280); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);